<template>
  <form @submit.prevent="handleSubmit" novalidate>
    <div class="form-group">
      <div class="title" style="margin-bottom: 6px;">
        <div class="tag hissu" style="padding: 2px 4px;">必須</div>
        <div class="txt">ご希望の勤務地</div>
      </div>
      <div class="box">
        <select
          v-model="form.desired_prefecture"
          class="form-select-custom"
          :disabled="isLoading"
        >
          <option value="">選択してください</option>
          <option v-for="pref in prefectures" :key="pref" :value="pref">{{ pref }}</option>
        </select>
        <p v-if="errors.desired_prefecture" class="error-text">{{ errors.desired_prefecture }}</p>
      </div>
    </div>

    <div class="form-group">
      <div class="title">
        <div class="tag ninni">任意</div>
        <div class="txt">ご希望の転職時期</div>
      </div>
      <div class="box">
        <div class="box-wrap">
          <div v-for="option in timingOptions" :key="option.value" class="box">
            <input
              type="radio"
              :id="'time-' + option.value"
              name="job_change_timing"
              :value="option.value"
              v-model="form.job_change_timing"
              :disabled="isLoading"
            />
            <label :for="'time-' + option.value">{{ option.label }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="slide_control_group">
      <button type="submit" class="form_button" :disabled="isLoading">次へ</button>
    </div>
  </form>
</template>

<script>
import { PREFECTURES, TIMING_OPTIONS } from '../../../lib/lp_gym01/constants'

export default {
  name: 'Step1Form',
  emits: ['submit'],
  props: {
    defaultValues: { type: Object, default: () => ({}) },
    isLoading: { type: Boolean, default: false }
  },
  data () {
    return {
      prefectures: PREFECTURES,
      timingOptions: TIMING_OPTIONS,
      form: {
        desired_prefecture: this.defaultValues.desired_prefecture || '',
        job_change_timing: this.defaultValues.job_change_timing || ''
      },
      errors: {}
    }
  },
  methods: {
    validate () {
      this.errors = {}
      if (!this.form.desired_prefecture) {
        this.errors.desired_prefecture = 'ご希望の勤務地を選択してください'
      }
      return Object.keys(this.errors).length === 0
    },
    handleSubmit () {
      if (!this.validate()) return
      this.$emit('submit', { ...this.form })
    }
  }
}
</script>

<style scoped>
.error-text {
  margin-top: 4px;
  font-size: 12px;
  color: #ef4444;
}
</style>
